import siteTheme from '@common/resources/SiteTheme/reducers';
import subscriptions, { subscription } from '@resources/Subscription/reducers';

export const reducers = { siteTheme, subscriptions, subscription };
